import React from 'react';
import './primaryshortcta.css'

const Primaryctashort = (props) => {
    return ( 
        <button className='short-cta-bg'>
            <nav className='yellow-cont-bg'>
                <h2 className='cta-text-primary'>{props.title}</h2>
            </nav>
        </button>
     );
}
 
export default Primaryctashort;